import { v4 as uuidv4 } from 'uuid';

export function MegaMenuTriggerBtn(props = {}, childrenComponents = []) {
	return {
		componentName: 'MegaMenuTriggerBtn',
		componentId: uuidv4(),
		props: Object.assign(
			{
				mzShow: false,
				id: 'icon-menu-btn',
				size: 13,
				viewBox: '0 0 24 24',
			},
			props,
		),
		childrenComponents,
	};
}
